/* eslint-disable @typescript-eslint/no-explicit-any */

// Inspired by https://github.com/vesln/timekeeper/

/**
 * Native Date constructor reference.
 */
const NativeDate = Date;

/**
 * Fake date time container.
 */
let travelTime: number | null = null;

/**
 * Travel start container.
 */
let startedTime: number | null = null;

/**
 * Return the elapsed time.
 */
function time() {
  if (!travelTime || !startedTime) {
    return NativeDate.now();
  }

  return travelTime + (NativeDate.now() - startedTime);
}

/**
 * `FakeDate` constructor.
 */
function FakeDate(...args: any[]) {
  if (this instanceof NativeDate) {
    if (!args.length && travelTime) {
      return new NativeDate(time());
    }

    const date =
      args.length == 1 && String(args[0]) === args[0] // isString(Y)
        ? // We explicitly pass it through parse:
          new NativeDate(NativeDate.parse(args[0]))
        : // We have to manually make calls depending on argument
          new (NativeDate as any)(...args);
    // Prevent mixups with unfixed Date object
    date.constructor = NativeDate;
    return date;
  }
  return NativeDate.apply(this, args);
}

// Copy any custom methods a 3rd party library may have added
for (const key in NativeDate) {
  (FakeDate as any)[key] = (NativeDate as any)[key];
}

// Copy "native" methods explicitly; they may be non-enumerable
FakeDate.UTC = NativeDate.UTC;
FakeDate.parse = NativeDate.parse;

// Setup inheritance
FakeDate.prototype = NativeDate.prototype;
FakeDate.prototype.constructor = NativeDate;

/**
 * Replace the original now method.
 *
 */
FakeDate.now = function () {
  return time();
};

/**
 * Set current DateTime.
 */
export function timeTravel(date: Date | string | number) {
  switchToFakeDate();

  if (typeof date !== 'object') {
    date = new NativeDate(date);
  }

  travelTime = date.getTime();
  startedTime = NativeDate.now();
}

/**
 * Reset the `timekeeper` behavior.
 */
export function timeTravelReset() {
  switchToNativeDate();
  startedTime = null;
  travelTime = null;
}

/**
 * Replace the `Date` with `FakeDate`.
 */
function switchToFakeDate() {
  (window as any).Date = FakeDate;
}

/**
 * Restore the `Date` to `NativeDate`.
 */
function switchToNativeDate() {
  window.Date = NativeDate;
}
